module.exports = __webpack_public_path__ + "static/media/ArrowUp.46607288.svg";